import { Injectable } from '@angular/core';
import { firstValueFrom, of } from 'rxjs';
import { catchError, mapTo } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { PwaAuthApiService } from './pwa-auth-api.service';

@Injectable({
  providedIn: 'root'
})
export class PwaSessionBootstrapService {
  constructor(
    private readonly authService: AuthService,
    private readonly pwaAuthApiService: PwaAuthApiService
  ) {}

  public async initialize(): Promise<void> {
    if (this.authService.isAuthenticated()) {
      await firstValueFrom(
        this.pwaAuthApiService.fetchMe().pipe(
          mapTo(void 0),
          catchError(() => of(void 0))
        )
      );
      return;
    }

    await firstValueFrom(
      this.pwaAuthApiService.ensureGuestSession().pipe(
        mapTo(void 0),
        catchError(() => of(void 0))
      )
    );
  }
}
